<app-scroll-top></app-scroll-top>
<div class="faq-page min-h-50">
    <div class="slider-bg-img gradient01 ">
        <div class="container">
            <nav class="py-4">
                <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
                    <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">FAQ</span></li>
                </ol>
            </nav>
            <div class="row row-cols-md-2 row-cols-sm-1 ">
                <div class="slider-txt py-md-5 py-sm-2">
                    <div class="h-100">
                        <h1 class="heading">
                            FOIRE AUX <span style="color : #BADFFF"> QUESTIONS </span>
                        </h1>
                        <h6 class="description">
                            Vous trouverez un certain nombre de réponses sur le fonctionnement du réseau national immobilier THE DOOR MAN
                            que vous soyez un vendeur, un acquéreur ou un professionnel de l’immobilier partenaire. Dans
                            le cas où vous ne trouveriez aucune réponse adaptée à l’une de vos questions, n’hésitez pas
                            à en faire part aux équipes THE DOOR MAN qui se feront un plaisir de vous répondre.
                        </h6>
                    </div>
                    <div>
                    </div>
                </div>
                <div class="slider-img">
                    <img width="584" height="641" src="../../../assets/formulaire/bg.webp" alt="Interieur cosi">
                </div>
            </div>
        </div>
    </div>
    <div class="faq-bloc py-5">
        <div class="container content">
            <div id="accordion">
                <div *ngFor="let faq of faqs | keyvalue" [id]="convertIdForAncre(faq.key)" class="my-5">
                    <div class="text-uppercase my-3">
                        <h3>{{faq.key}}</h3>
                    </div>
                    <div ngbAccordion>
                        <div ngbAccordionItem *ngFor="let faqItem of $any(faq).value">
                            <h4 ngbAccordionHeader>
                                <button ngbAccordionButton>{{faqItem.Question}}</button>
                            </h4>
                            <div ngbAccordionCollapse>
                                <div ngbAccordionBody>
                                    <ng-template>
                                        <div [innerHTML]="faqItem.Reponse"></div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
